import { CalendarClock, Check, ListChecks } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

import { api } from "@/api";
import { Skeleton } from "@/components/cockpit/BriefingCard";
import { useAuth } from "@/auth";
import { parisDay } from "@/components/projects/AllTasksBoard";

// Encart « Mes tâches du jour » : en retard + échéance aujourd'hui + en cours
export const MyTasksToday = () => {
  const { user } = useAuth();
  const [todos, setTodos] = useState(null);
  const today = parisDay();
  const load = useCallback(() => api.get("/tasks", { params: { assignee: user.id } }).then(({ data }) => setTodos(data.todos.filter((t) => t.status !== "done" && ((t.due_date && t.due_date <= today) || t.status === "doing")))).catch(() => setTodos([])), [user.id, today]);
  useEffect(() => { load(); }, [load]);
  const done = async (t) => {
    await api.patch(`/projects/${t.project_id}/todos/${t.id}`, { status: "done" });
    toast.success("Tâche terminée.");
    window.dispatchEvent(new Event("tasks-changed"));
    load();
  };
  return (
    <section className="bf-card mt-card" data-testid="ck-my-tasks">
      <header>
        <h3 className="mt-title"><ListChecks size={16} /> Mes tâches du jour <span className="pj-count" data-testid="ck-my-tasks-count">{todos ? todos.length : "…"}</span></h3>
        <Link to="/projets?vue=taches" className="mt-all" data-testid="ck-my-tasks-all">Toutes mes tâches →</Link>
      </header>
      {todos === null ? <Skeleton lines={2} testid="ck-my-tasks-loading" /> : todos.length === 0 ? <p className="bf-empty" data-testid="ck-my-tasks-empty">Rien en retard ni prévu aujourd'hui. Bravo !</p> : (
        <ul className="mt-list">
          {todos.map((t) => {
            const late = t.due_date && t.due_date < today;
            return (
              <li key={t.id} data-testid={`ck-my-task-${t.id}`}>
                <button type="button" className="mt-check" onClick={() => done(t)} title="Marquer terminée" data-testid={`ck-my-task-done-${t.id}`}><Check size={13} /></button>
                <Link to={`/projets/${t.project_id}?tab=todos&todo=${t.id}`} className="mt-name" data-testid={`ck-my-task-open-${t.id}`}>{t.title}</Link>
                <small>{t.project_name}</small>
                {t.due_date && <span className={late ? "mt-due late" : "mt-due"}><CalendarClock size={12} />{late ? "En retard · " : ""}{new Date(t.due_date).toLocaleDateString("fr-FR", { day: "numeric", month: "short" })}</span>}
                {t.status === "doing" && <span className="pj-pill">En cours</span>}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};
